import React from 'react';
import { NavLink } from 'react-router-dom';

function Navbar() {
  return (
    <header className="navbar">
      <div className="navbar-container">
        {/* Logo (assurez-vous que "logo-wayagri.png" est dans le dossier public) */}
        <div className="logo">
          <img src="/logo-wayagri.png" alt="Way-Agri Logo" className="logo-img" />
        </div>
        {/* Navigation */}
        <nav>
          <ul className="nav-links">
            <li>
              <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                Accueil
              </NavLink>
            </li>
            <li>
              <NavLink to="/formation" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                Formation
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                Contact
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
